/**
 * 悬浮按钮集合
 */
import React, { FC } from 'react'
import './index.scss'
import { multiPersonMobx } from '@mobxStore'
import CouponBar from './CouponBar'
import BuyTogetherBar from './BuyTogetherBar'
import ThirdCouponBar from './ThirdCouponBar'

interface IProps {
  style: { [key: string]: any };
}

const BTAndCouponBar: FC<IProps> = ({ style }) => {
  return (
    <div
      className='waterfall-coupon-buyTogether-wrapper product-item waterfall mini'
      style={style}
      id='waterfallproductcoupon'
    >
      {
        (!Config.buyTogetherId || Config.buyTogetherId && multiPersonMobx.getCurrentPersonInfo().isOwner) && (
          <>
            <CouponBar />
            <ThirdCouponBar />
          </>
        )
      }
      <BuyTogetherBar />
    </div>
  )
}
export default BTAndCouponBar
